<ft-modal-overlay [open]="true">
  <div id="accountv2.CampaignContainer" ft-ensure-modal-single-scroll>
    <div class="ft-touchpoint ft-campaign">
      <header class="ft-touchpoint-header">
        <button class="ft-btn-close" (click)="closeContainer()"></button>
        <div class="ft-modal-id">
          @if (isCreating()) {
            <div>
              <h1 class="ft-modal-name ft-text-plus-3">New Variation</h1>
            </div>
          }
          @if (!isCreating()) {
            <div>
              <p class="ft-supertitle">{{ 'flipto.account.Variation' | translate }}</p>
              <h1 class="ft-modal-name ft-text-plus-3">{{ campaignTitle() }}</h1>
              <ft-switch [hidden]="!showActivate()"
                         [state]="!!chc().isActive"
                         (stateChange)="chc().isActive = $event"
                         (change)="updateState()" />
            </div>
          }
        </div>
      </header>
      <main class="ft-touchpoint-main">
        <section class="ft-master-section ft-campaign-master">
          @switch (nativeBranch()) {
            @case ('prestay') {
              <ft-campaign-prestay-ng [campaignId]="campaignUuid()"
                                      [layerName]="layerName()"
                                      [propertyUuid]="propertyUuid()"
                                      [isCreating]="isCreating()"
                                      (created)="onCampaignCreated($event)"
                                      (requestClose)="closeContainer()" />
            }
            @case ('goals-only') {
              <ft-campaign-goals-only-ng [campaignId]="campaignUuid()"
                                         [layerName]="layerName()"
                                         [propertyUuid]="propertyUuid()"
                                         [isCreating]="false" />
            }
          }
        </section>
      </main>
    </div>
  </div>
</ft-modal-overlay>
